<script setup lang="ts">
import type { Question } from '../types/questionnaire'

defineProps<{
  question: Question
  modelValue: string
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()
</script>

<template>
  <section class="question-block question-block--text">
    <label class="memory-question-label" :for="question.code">
      {{ question.title }}
      <span v-if="question.required" class="required-mark">*</span>
    </label>
    <div class="memory-input-wrap">
      <input
        :id="question.code"
        class="memory-input"
        :value="modelValue"
        :placeholder="question.config?.placeholder"
        :maxlength="question.config?.maxLength"
        autocomplete="off"
        @input="emit('update:modelValue', ($event.target as HTMLInputElement).value)"
      />
      <span class="input-counter">
        {{ modelValue.length }}/{{ question.config?.maxLength || 20 }}
      </span>
    </div>
  </section>
</template>

